import { combineReducers } from 'redux';

import apmBom from './apmBom';
import apmCameras from './apmCameras';
import apmChecklistInstances from './apmChecklistInstances';
import apmDefaultWarranty from './apmDefaultWarranty';
import apmIssues from './apmIssues';
import apmMonitoringServices from './apmMonitoringServices';
import apmProvision from './apmProvision';
import apmSeriesDatapoints from './apmSeriesDatapoints';
import apmTemperatures from './apmTemperatures';
import apmTriggers from './apmTriggers';
import apmZabbixHistory from './apmZabbixHistory';
import apmZabbixItems from './apmZabbixItems';
import apmZabbixTriggers from './apmZabbixTriggers';
import checklistInstanceAttachments from './checklistInstanceAttachments';
import clusterMonitoringServices from './clusterMonitoringServices';
import clusterZabbixItems from './clusterZabbixItems';
import clusterZabbixTriggers from './clusterZabbixTriggers';
import collectionModal from './collectionModal';
import apmInvoicings from './collections/apmInvoicings';
import apmLocationInfo from './collections/apmLocationInfo';
import apmModels from './collections/apmModels';
import apms from './collections/apms';
import apmSeries from './collections/apmSeries';
import apmSeriesCameras from './collections/apmSeriesCameras';
import apmServiceHistory from './collections/apmServiceHistory';
import checklistInstances from './collections/checklistInstances';
import checklists from './collections/checklists';
import clusters from './collections/clusters';
import clusterTypeMonitoringServices from './collections/clusterTypeMonitoringServices';
import clusterTypes from './collections/clusterTypes';
import companies from './collections/companies';
import companyAPMGroups from './collections/companyAPMGroups';
import companyWebhooks from './collections/companyWebhooks';
import datapoints from './collections/datapoints';
import deliveryApms from './collections/deliveryApms';
import devices from './collections/devices';
import issueLabels from './collections/issueLabels';
import issues from './collections/issues';
import maintenance from './collections/maintenance';
import maintenanceIssues from './collections/maintenanceIssues';
import monitoringServices from './collections/monitoringServices';
import notificationTemplates from './collections/notificationTemplates';
import partChangeOrders from './collections/partChangeOrders';
import pendingApms from './collections/pendingApms';
import reactiveMaintenanceIssues from './collections/reactiveMaintenanceIssues';
import releaseNotes from './collections/releaseNotes';
import scConnections from './collections/scConnections';
import scenarios from './collections/scenarios';
import servers from './collections/servers';
import serverTypeControlTools from './collections/serverTypeControlTools';
import serverTypes from './collections/serverTypes';
import sparePartArticles from './collections/sparePartArticles';
import sparePartOrders from './collections/sparePartOrders';
import tickets from './collections/tickets';
import webhookTypes from './collections/webhookTypes';
import companyContactInfo from './companyContactInfo';
import customerIssueApms from './customerIssueApms';
import customerIssueUsers from './customerIssueUsers';
import customerPortal from './customerPortal';
import darkMode from './darkMode';
import deviceZabbixHosts from './deviceZabbixHosts';
import directoCustomers from './directoCustomers';
import environments from './environments';
import hostnameConfigs from './hostnameConfigs';
import issueComponents from './issueComponents';
import issuePartnerEvaluationReasons from './issuePartnerEvaluationReasons';
import issuePartnerEvaluations from './issuePartnerEvaluations';
import issueRootCauses from './issueRootCauses';
import issueStatistics from './issueStatistics';
import jiraConfig from './jiraConfig';
import jiraFilters from './jiraFilters';
import jiraStatistics from './jiraStatistics';
import locale from './locale';
import location from './location';
import locationInfoValues from './locationInfoValues';
import menu from './menu';
import notificationTemplateTypes from './notificationTemplateTypes';
import provision from './provision';
import s2Clients from './s2Clients';
import s2StaticData from './s2StaticData';
import serverControlTools from './serverControlTools';
import serverTypeDatapoints from './serverTypeDatapoints';
import snackbar from './snackbar';
import sparePartArticlesImport from './sparePartArticlesImport';
import ticketAssignees from './ticketAssignees';
import version from './version';
import zabbixTemplateItems from './zabbixTemplateItems';
import zabbixTemplateTriggers from './zabbixTemplateTriggers';
import zabbixTriggerDefinitions from './zabbixTriggerDefinitions';
import zabbixTriggerRadar from './zabbixTriggerRadar';

const rootReducer = combineReducers({
    apmBom,
    apmCameras,
    apmChecklistInstances,
    apmDefaultWarranty,
    apmInvoicings,
    apmIssues,
    apmLocationInfo,
    apmModels,
    apmMonitoringServices,
    apmProvision,
    apms,
    apmSeries,
    apmSeriesCameras,
    apmSeriesDatapoints,
    apmServiceHistory,
    apmTemperatures,
    apmTriggers,
    apmZabbixHistory,
    apmZabbixItems,
    apmZabbixTriggers,
    checklistInstanceAttachments,
    checklistInstances,
    checklists,
    clusterMonitoringServices,
    clusters,
    clusterTypeMonitoringServices,
    clusterTypes,
    clusterZabbixItems,
    clusterZabbixTriggers,
    collectionModal,
    companies,
    companyAPMGroups,
    companyContactInfo,
    companyWebhooks,
    customerIssueApms,
    customerIssueUsers,
    customerPortal,
    darkMode,
    datapoints,
    deliveryApms,
    devices,
    deviceZabbixHosts,
    directoCustomers,
    environments,
    hostnameConfigs,
    issueComponents,
    issueLabels,
    issuePartnerEvaluationReasons,
    issuePartnerEvaluations,
    issueRootCauses,
    issues,
    issueStatistics,
    jiraConfig,
    jiraFilters,
    jiraStatistics,
    locale,
    location,
    locationInfoValues,
    maintenance,
    maintenanceIssues,
    menu,
    monitoringServices,
    notificationTemplates,
    notificationTemplateTypes,
    partChangeOrders,
    pendingApms,
    provision,
    reactiveMaintenanceIssues,
    releaseNotes,
    s2Clients,
    s2StaticData,
    scenarios,
    serverControlTools,
    servers,
    serverTypeControlTools,
    serverTypeDatapoints,
    serverTypes,
    scConnections,
    snackbar,
    sparePartArticles,
    sparePartArticlesImport,
    sparePartOrders,
    ticketAssignees,
    tickets,
    version,
    webhookTypes,
    zabbixTemplateItems,
    zabbixTemplateTriggers,
    zabbixTriggerDefinitions,
    zabbixTriggerRadar,
});

export default rootReducer;
